import styled, { css } from 'styled-components';
import { planSectionHeight, trackPaddingSize, planSectionMinimalWidth, planContainerWidth, planContainerHeight, knobDiameter } from './constants.js';
import { PointSectionComponent } from './PointSection.js';

const Selector = styled.div.withConfig({
    displayName: "styles__Selector",
    componentId: "sc-92585b34-0"
})`
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-touch-callout: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
`;
const Container = styled.div.withConfig({
    displayName: "styles__Container",
    componentId: "sc-92585b34-1"
})`
    display: flex;
    position: relative;
    flex: 1 1 auto;
`;
const KnobContainer = styled.div.withConfig({
    displayName: "styles__KnobContainer",
    componentId: "sc-92585b34-2"
})`
    position: absolute;
    top: -10px;
    left: 0;
    transition: ${(props)=>props.animated ? `transform 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)` : "none"};
    transition-delay: ${(props)=>props.animated ? ".05s" : "none"};
`;
const Track = styled.div.withConfig({
    displayName: "styles__Track",
    componentId: "sc-92585b34-3"
})`
    display: flex;
    overflow: hidden;
    height: ${planSectionHeight}px;
    padding: 0 ${trackPaddingSize}px;
    box-sizing: border-box;
    flex: 1 0 auto;
    border-radius: ${planSectionHeight}px;
    cursor: pointer;
    letter-spacing: 0.05em;
    border: 2px solid ${({ theme  })=>`${theme.colors["Level 1"]}`};
`;
const PointSection = styled(PointSectionComponent).withConfig({
    displayName: "styles__PointSection",
    componentId: "sc-92585b34-4"
})`
    flex: 1 1 auto;
    min-width: ${planSectionMinimalWidth}px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    user-select: none;
    mix-blend-mode: normal;

    &:first-child,
    &:last-child {
        flex-grow: 1;
        overflow: ${(props)=>props.$isShortVersion ? "initial" : "visible"};
        justify-content: ${(props)=>props.$isShortVersion ? "center" : "unset"};
        justify-content: center;
    }
`;
const Point = styled.div.withConfig({
    displayName: "styles__Point",
    componentId: "sc-92585b34-5"
})`
    width: ${planContainerWidth}px;
    height: ${planContainerHeight}px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: ${({ hasAccentColors , isDisabled , backgroundColor  })=>isDisabled ? "none" : hasAccentColors ? backgroundColor : "none"};

    &--firstChild {
        transform: ${(props)=>props.isShortVersion ? "initial" : "translateX(-50%)"};
    }

    &--lastChild {
        transform: ${(props)=>props.isShortVersion ? "initial" : "translateX(50%)"};
    }
`;
const TrackValue = styled.div.withConfig({
    displayName: "styles__TrackValue",
    componentId: "sc-92585b34-6"
})`
    box-sizing: content-box;
    text-overflow: ellipsis;
    overflow: hidden;
    ${(props)=>css(props.theme.typography.SmallCapsHeadline)};
    line-height: 18px;
    text-align: center;
    color: ${({ hasAccentColors , isDisabled , textColor , theme  })=>isDisabled ? theme.colors["Level 2"] : hasAccentColors ? textColor : theme.colors["Level 4"]};
`;
const TrackValuePlus = styled.span.withConfig({
    displayName: "styles__TrackValuePlus",
    componentId: "sc-92585b34-7"
})``;
const Knob = styled.div.withConfig({
    displayName: "styles__Knob",
    componentId: "sc-92585b34-8"
})`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: ${knobDiameter}px;
    height: ${knobDiameter}px;
    background-color: ${({ hasAccentColors , isDisabled , backgroundColor , theme  })=>isDisabled ? "#e0e0e0" : hasAccentColors ? backgroundColor : theme.colors.Background};
    border-radius: 50%;
    cursor: pointer;
    user-select: none;
    overflow: hidden;
    transform: ${(props)=>props.isPressed ? "scale(1)" : "scale(1.1)"};
    box-shadow: ${(props)=>props.isPressed ? ` 0px 2px 6px rgba(0, 0, 0, 0.13)` : `0px 4px 10px rgba(0, 0, 0, 0.13)`};

    &:hover {
        box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.13);
    }
`;
const KnobValue = styled.div.withConfig({
    displayName: "styles__KnobValue",
    componentId: "sc-92585b34-9"
})`
    ${(props)=>css(props.theme.typography.Subheadline)};
    display: flex;
    margin: 0 auto;
    text-overflow: ellipsis;
    text-align: center;
    text-transform: uppercase;
    color: ${({ hasAccentColors , isDisabled , textColor , theme  })=>isDisabled ? "#fff" : hasAccentColors ? textColor : theme.colors.Foreground};
    transition: color 100ms linear;
`;
const KnobValuePlus = styled.span.withConfig({
    displayName: "styles__KnobValuePlus",
    componentId: "sc-92585b34-10"
})`
    font-size: 16px;
`;
const Label = styled.div.withConfig({
    displayName: "styles__Label",
    componentId: "sc-92585b34-11"
})`
    display: block;
    ${(props)=>css(props.theme.typography.SmallCapsHeadline)};
    font-size: 8px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    font-style: normal;
    line-height: normal;
    font-weight: bold;
    text-align: center;
    color: ${({ hasAccentColors , isDisabled , textColor , theme  })=>isDisabled ? "#fff" : hasAccentColors ? textColor : theme.colors["Level 4"]};
    transition: color 100ms linear;
`;

export { Container, Knob, KnobContainer, KnobValue, KnobValuePlus, Label, Point, PointSection, Selector, Track, TrackValue, TrackValuePlus };
